import React from 'react'

function SectionHeading(props) {
  return (
    <div className='lg:ml-36 mb-20 xl:ml-[80px] mb-[20px] sm:mt-[25px] flex flex-col items-left lg:items-start text-left lg:text-left justify-center flex-1 px-4 lg:px-0'>
    <h1 style={{fontSize: "2.5rem",color:"#235784"}}>{props.title}</h1>
    </div>
  )
}



export default SectionHeading

